import { render, staticRenderFns } from "./WorkCardRepairDetail.vue?vue&type=template&id=b924b7ac&scoped=true&lang=pug"
import script from "./WorkCardRepairDetail.vue?vue&type=script&lang=js"
export * from "./WorkCardRepairDetail.vue?vue&type=script&lang=js"
import style0 from "./WorkCardRepairDetail.vue?vue&type=style&index=0&id=b924b7ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b924b7ac",
  null
  
)

export default component.exports